import { useCallback } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { Button } from '~/components/Button'
import MakerHubProjectCard from '~/components/MakerHubProjectCard/MakerHubProjectCard'
import { SectionContainer } from '~/components/SectionContainer'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './ProjectInterestedIn.module.scss'
import { ProjectInterestedInProps } from './ProjectInterestedIn.types'

const BUTTON_TITLE = 'See more Projects'
const SIMILAR_PROJECTS_LABEL = 'Similar projects you may be interested in'

export const ProjectInterestedIn = ({
  projects,
  width,
}: ProjectInterestedInProps) => {
  const router = useRouter()

  const onClick = useCallback(() => {
    router.replace(`/projects`)
  }, [router])

  return (
    <SectionContainer width={width}>
      <div className='flex flex-col items-center gap-y-10 py-4 px-6 mb-10 md:py-4 md:px-6 lg:py-4 lg:px-20'>
        <Typography
          className={classNames('mt-8 mb-4')}
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyLargeBold}>
          {SIMILAR_PROJECTS_LABEL}
        </Typography>
        <div className='grid grid-cols-1 lg:grid-cols-4 gap-x-4'>
          {projects.map((project, index) => {
            return <MakerHubProjectCard {...project} key={index} />
          })}
        </div>

        <div
          className={classNames(
            styles.wrapper,
            `text-center w-[163px] ${width} 2xl:w-full`
          )}>
          <Button
            status='secondary'
            theme={{ root: 'w-full h-[44px] normal-case !rounded' }}
            ariaLabel={BUTTON_TITLE}
            onClick={onClick}>
            <Typography
              tag={TypographyTag.span}
              variant={TypographyVariant.BodyRegularBold}>
              {BUTTON_TITLE}
            </Typography>
          </Button>
        </div>
      </div>
    </SectionContainer>
  )
}
